import React from "react";
import { Typography } from "@mui/material";
import {
    CHUIMuliLineTextfield,
    CHUITextfieldWithFollowUpSlider,
    CHUIRadioWithFollowUpCheckBox,
    CHUIRadioButtons,
    CHUIRadioWithFollowUpRadioButtons,
    CHUIRadioWithFollowUpTextFieldQuestion,
    CHUIShortTextfield,
    CHUITimePicker,
    CHUIDatePicker,
    CHUISlider,
    CHUICheckBoxes,
    CHUICheckBoxesWithAssociatedTextField,
    CHUIPainDiagram,
    CHUICollapsibleTable,
} from "@connecthealth-ui/core";

import RadioButtonsSuicidalThoughts from "./RadioButtonsSuicidalThoughts";
import PainWorkStatus from "./PainWorkStatus";

const Element = (
    {
        questions: {
            id,
            question,
            questions,
            heading,
            increment,
            customChoiceOption,
            subQuestionInfo,
            followUpQuestion,
            followUpCheckBoxes,
            subFollowUpQuestionInfo,
            followUpOption,
            sliderRange,
            answerType,
            options,
            name,
            value,
            label,
            checkBoxes,
            optionsArray,
            followUpOptions,
            subQuestions,
            checkBoxesTitle,
            textFieldTitle,
            marks,
            row,
            selectColours,
            support,
            changePositionText,
            labels,
            questionCText,
            listHeaderId,
            requiredQuestions,
            triggerAnswers,
            rowManagerButtons,
            readOnly,
        },
    },
    questionClass
) => {
    switch (answerType) {
        case "MultilineTextField":
            return (
                <CHUIMuliLineTextfield
                    className={questionClass}
                    name={name}
                    id={id}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                />
            );

        case "RadioWithFollowUpTextFieldQuestion":
            return (
                <CHUIRadioWithFollowUpTextFieldQuestion
                    className={questionClass}
                    options={options}
                    name={name}
                    id={id}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    followUpQuestion={followUpQuestion}
                    subFollowUpQuestionInfo={subFollowUpQuestionInfo}
                    followUpOption={followUpOption}
                />
            );

        case "RadioWithFollowUpCheckBoxes":
            return (
                <CHUIRadioWithFollowUpCheckBox
                    id={id}
                    name={name}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    options={options}
                    followUpQuestion={followUpQuestion}
                    subFollowUpQuestionInfo={subFollowUpQuestionInfo}
                    followUpOption={followUpOption}
                    followUpCheckBoxes={followUpCheckBoxes}
                    className={questionClass}
                />
            );

        case "RadioButtons":
            return (
                <CHUIRadioButtons
                    id={id}
                    name={name}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    options={options}
                    className={questionClass}
                    customChoiceOption={customChoiceOption}
                    row={row}
                />
            );

        case "RadioButtonsSuicidalThoughts":
            return (
                <RadioButtonsSuicidalThoughts
                    id={id}
                    name={name}
                    question={question}
                    triggerAnswers={triggerAnswers}
                    subQuestionInfo={subQuestionInfo}
                    options={options}
                    className={questionClass}
                />
            );

        case "ShortTextField":
            return (
                <CHUIShortTextfield
                    id={id}
                    name={name}
                    question={question}
                    support={support}
                    subQuestionInfo={subQuestionInfo}
                    className={questionClass}
                />
            );

        case "DatePicker":
            return (
                <CHUIDatePicker
                    id={id}
                    name={name}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    className={questionClass}
                />
            );

        case "TimePicker":
            return (
                <CHUITimePicker
                    id={id}
                    name={name}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    increment={increment}
                    className={questionClass}
                />
            );

        case "Slider":
            return (
                <CHUISlider
                    className={questionClass}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    sliderRange={sliderRange}
                    name={name}
                    id={id}
                    increment={increment}
                    customMarks={marks}
                />
            );

        case "CheckBoxes":
            return (
                <CHUICheckBoxes
                    className={questionClass}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    checkBoxes={checkBoxes}
                    name={name}
                    id={id}
                />
            );

        case "RadioWithFollowUpRadioButtons":
            return (
                <CHUIRadioWithFollowUpRadioButtons
                    className={questionClass}
                    name={name}
                    id={id}
                    optionsArray={optionsArray}
                    followUpOptions={followUpOptions}
                    questions={questions}
                    subQuestions={subQuestions}
                />
            );

        case "CheckBoxesWithAssociatedTextField":
            return (
                <CHUICheckBoxesWithAssociatedTextField
                    id={id}
                    name={name}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    options={options}
                    followUpQuestion={followUpQuestion}
                    subFollowUpQuestionInfo={subFollowUpQuestionInfo}
                    followUpOption={followUpOption}
                    followUpCheckBoxes={followUpCheckBoxes}
                    className={questionClass}
                    checkBoxesTitle={checkBoxesTitle}
                    textFieldTitle={textFieldTitle}
                />
            );

        case "TextfieldWithFollowUpSlider":
            return (
                <CHUITextfieldWithFollowUpSlider
                    className={questionClass}
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    sliderRange={sliderRange}
                    name={name}
                    id={id}
                    increment={increment}
                    label={label}
                    customMarks={marks}
                    readOnly={readOnly}
                />
            );

        case "painWorkStatus":
            return (
                <PainWorkStatus
                    questions={questions}
                    options={options}
                    questionCText={questionCText}
                    subQuestionInfo={subQuestionInfo}
                    name={name}
                    id={id}
                />
            );

        case "header":
            const headingArray = heading.split("[NEWLINE]");
            return (
                <Typography style={{ textAlign: "center" }}>
                    {headingArray ? headingArray.map((element) => <h2 name={name}> {element} </h2>) : null}
                </Typography>
            );

        case "painDiagram":
            return (
                <CHUIPainDiagram
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    name={name}
                    selectColours={selectColours}
                    changePositionText={changePositionText}
                    labels={labels}
                    id={id}
                />
            );

        case "CollapsibleTable":
            return (
                <CHUICollapsibleTable
                    question={question}
                    subQuestionInfo={subQuestionInfo}
                    questions={questions}
                    listHeaderId={listHeaderId}
                    rowManagerButtons={rowManagerButtons}
                    name={name}
                    id={id}
                    requiredQuestions={requiredQuestions}
                />
            );

        default:
            return null;
    }
};

export default Element;
